<script setup>
defineProps({
  author: { type: Object, required: true },
});
const roleLabel = role =>
  ({
    member: 'Membro',
    contributor: 'Colaborador',
    moderator: 'Moderador',
    administrator: 'Administrador',
  })[role] || 'Membro';
</script>

<template>
  <div
    class="flex min-w-0 items-center gap-3 border-b border-n-weak bg-n-alpha-1 p-4 sm:flex-col sm:border-b-0 sm:border-r sm:py-6 sm:text-center"
  >
    <img
      v-if="author.avatar_url"
      :src="author.avatar_url"
      :alt="author.name"
      class="size-12 shrink-0 rounded-full object-cover sm:size-16"
    />
    <span
      v-else
      class="grid size-12 shrink-0 place-items-center rounded-full bg-n-brand/10 text-lg font-semibold text-n-brand sm:size-16 sm:text-2xl"
      aria-hidden="true"
      >{{ author.name.charAt(0) }}</span
    >
    <div class="min-w-0">
      <p class="break-words text-sm font-semibold text-n-slate-12">
        {{ author.name }}
      </p>
      <p class="mt-1 text-xs text-n-slate-11">{{ roleLabel(author.role) }}</p>
      <p v-if="author.title" class="mt-1 break-words text-xs text-n-slate-11">
        {{ author.title }}
      </p>
    </div>
  </div>
</template>
